import Link from '../components/ui/Link';
import SegmentedControl from '../components/ui/SegmentedControl';
import { getPaymentIntervalOptions } from './plan';

export const getHeaderContentByStep = ({ getLabel, onChangePlan, paymentInterval, plan, setPaymentInterval, step }) => {
	switch (step) {
		case 0:
			return plan.payment_interval !== '' ? (
				<label className="prc-plan__payment">{getLabel(`payment_only_${paymentInterval}`)}</label>
			) : (
				<SegmentedControl
					options={getPaymentIntervalOptions(getLabel)}
					value={paymentInterval}
					onChange={(value) => {
						setPaymentInterval(value);
					}}
				/>
			);

		default:
			return (
				<Link onClick={onChangePlan} small={true} testId="prc-link-change-plan">
					{getLabel('nav_prev_change_plan')}
				</Link>
			);
	}
};
